import { useTranslations } from '@vocab/react';
import { Box, Dialog, Notice, Text, TextLinkButton } from 'braid-design-system';
import { useState } from 'react';
import loadable from 'sku/@loadable/component';

import { LOADER_SIZE } from 'src/app/shared/constants/paymentInProgress';

import translations from './.vocab';

const Loader = loadable(
  () => import('./Loader').then((module) => ({ default: module.Loader })),
  { ssr: false, fallback: <Box style={{ height: LOADER_SIZE }} /> },
);

export interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const PaymentInProgressDialog = ({ isOpen, setIsOpen }: Props) => {
  const { t } = useTranslations(translations);
  const [attemptToClose, setAttemptToClose] = useState(false);

  return (
    <Dialog
      id="payment-in-progress"
      title={t('payment-in-progress-dialog-title')}
      width="xsmall"
      open={isOpen}
      onClose={() => {
        setAttemptToClose(true);
        return false;
      }}
      illustration={<Loader />}
    >
      <Box aria-live="assertive" aria-atomic="true">
        {attemptToClose ? (
          <Notice tone="critical">
            <Text align="center">
              {t('payment-in-progress-dialog-attempt-to-close-body-text')}
              <TextLinkButton
                onClick={() => {
                  setIsOpen(false);
                  setAttemptToClose(false);
                }}
              >
                {t('payment-in-progress-dialog-attempt-to-close-confirm-text')}
              </TextLinkButton>
            </Text>
          </Notice>
        ) : (
          <Text align="center">
            {t('payment-in-progress-dialog-body-text')}
          </Text>
        )}
      </Box>
    </Dialog>
  );
};
